module.exports = __webpack_public_path__ + "img/cp11.f743806b.png";